import React from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_CATEGORY } from 'models/constants';
import { DocumentationPage, ExposureType } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';
import { useAppSelector } from 'store/store';

type ServiceDescriptionTitleProps = {
    name: Nullable<string>;
    categoryKey: Nullable<string>;
    isInternal?: boolean;
    documentationPages?: DocumentationPage[];
};

export const ServiceDescriptionTitle: React.FunctionComponent<ServiceDescriptionTitleProps> = ({
    name,
    categoryKey,
    isInternal,
    documentationPages,
}) => {
    const { t: translateService } = useTranslation('service');
    const authenticatedUser = useAppSelector(state => state.applicationContext.context?.user);

    const apiUrl = authenticatedUser?.isInternal
        ? documentationPages?.filter(d => d.exposure === ExposureType.Staff)[0]?.url ?? ''
        : documentationPages?.filter(d => d.exposure === ExposureType.Client)[0]?.url ?? '';

    return (
        <div>
            <h3
                className="modal-title h3"
                id="serviceDescriptionTitle"
            >
                {name}
            </h3>
            <div className="d-flex align-items-center gap-2">
                <span className="text-large text-secondary mb-0">
                    {translateService(`${categoryKey}`) || DEFAULT_CATEGORY}
                </span>

            </div>
            {isInternal && (
                <span className="mt-2 badge badge-outline-danger badge-lg rounded-pill me-2">
                    {translateService('service-description:internal')}
                </span>
            )}
            {apiUrl &&
                <a href={apiUrl} target="_blank" rel="noopener noreferrer" className="mt-2 badge badge-outline-secondary badge-lg rounded-pill">
                    {translateService('service-description:api')}
                </a>}
        </div >
    );
};
